module.exports = __webpack_public_path__ + "static/glop_logo-f2e9ce3b18f6e94d13478780af919885.svg";